import { AxiosInstance } from 'axios'
import { BaseHTTP } from './base.http'


export class DashboardAPI {

  private http !: AxiosInstance

  constructor() {
    this.http = BaseHTTP.getInstance().http
  }

  getAdministrationDashboard(businessId: number, params: { year: number }) {
    const path = `v1/business/${businessId}/dashboard/administration`

    return this.http.get(path, { params })
  }

  regenerateDashboard(businessId: number) {
    const path = `v1/dashboard/${businessId}/regenerate`

    return this.http.post(path)
  }
}

export default new DashboardAPI()
